import backoffice from './backoffice';
import evisa from './evisa';
// import notices from './notices';

export default { backoffice, evisa };
